import { loadLists, addItemsToLists, createList, removeItemsFromList } from '../common/api';

const lists = {
    name: 'lists',
    state: { 
        names: [], 
        entries: {},
        currentId: '',
        byId: {}
    },
    reducers: {
        setCurrentId: ( state, payload ) => {
            return {
                ...state,
                currentId: payload.gid
            }
        },
        cdcInsert: ( state, payload ) => {
            return {
                ...state,
                byId: {
                    ...state.byId,
                    [payload.gid]: { 
                        id: payload.gid,
                        ...payload.cdc,
                        items: [],
                        count: 0,
                        ...state.byId[payload.gid]
                    }
                }
            }
        },
        cdcInsertItem: ( state, payload ) => {
            const [ gid, iid ] = payload.gid.split( '#' );
            let list = state.byId[gid];
            if ( !list ) {
                list = {
                    items: [],
                    count: 0
                }
            } else if ( !list.items ) {
                list['items'] = [];
                list['count'] = 0;
            }

            list.items.push( iid );
            list.count = list.items.length;
            
            return {
                ...state,
                byId: {
                    ...state.byId,
                    [gid]: { ...list }
                }
            }
        },
        cdcModify: ( state, payload ) => {
            return {
                ...state,
                byId: {
                    ...state.byId,
                    [payload.gid]: {
                        ...state.byId[payload.gid],
                        ...payload.cdc
                    }
                }
            }
        },
        cdcRemove: ( state, payload ) => {
            const keys = Object.keys( state.byId ).filter( f => f !== payload.gid );
            let newObj = {};
            keys.forEach( k => newObj[k] = state.byId[k] );
            return {
                ...state,
                byId: newObj
            }
        },
        cdcRemoveItem: ( state, payload ) => {
            console.log( 'cdcRemoveItem: ', payload );
            const [ gid, iid ] = payload.gid.split( '#' );
            const list = state.byId[gid];
            const items = list.items.filter( f => f !== iid );
            console.log( list, items );

            return {
                ...state,
                byId: {
                    ...state.byId,
                    [gid]: {
                        ...state.byId[gid],
                        cids: items,
                        items: items,
                        count: items.length
                    }
                }
            }
        },
        loadedLists: ( state, payload ) => {
            return {
                ...state,
                names: payload
            }
        },
        loadedListsById: ( state, payload ) => {
            return {
                ...state,
                byId: {
                    ...state.byId,
                    ...payload
                }
            }
        }
    },
    effects: ( dispatch ) => ( {
        async addItemsToLists( { aid, uid, gid, items, itemType } ) {
            const resp = await addItemsToLists( aid, uid, gid, items, itemType );
            return ( resp );
        },
        async createList( { aid, uid, name, items, itemType } ) {
            const resp = await createList( aid, uid, name, items, itemType );
            return ( resp );
        },
        async removeItem( { aid, uid, items, gid } ) {
            const resp = await removeItemsFromList( aid, uid, items, gid );
            return ( resp );
        },
        async removeContact( { aid, uid, contacts, gid } ) {
            const resp = await removeItemsFromList( aid, uid, contacts, gid );
            return ( resp );
        },
        async removeLoan( { aid, uid, loans, gid } ) {
            const resp = await removeItemsFromList( aid, uid, loans, gid );
            return ( resp );
        },
        async loadLists( { aid, uid } ) {
            const list = await loadLists( aid, uid );
            let byId = {};
            list.forEach( l => byId[l.gid] = l );
            dispatch.lists.loadedListsById( byId );
        },
        insert( { gid, cdc } ) {
            const member = gid.match( '#' );
            if ( member ) {
                dispatch.lists.cdcInsertItem( { gid, cdc } );
            } else {
                dispatch.lists.cdcInsert( { gid, cdc } );
            }
        },
        modify( { gid, cdc } ) {
            dispatch.lists.cdcModify( { gid, cdc } );
        },
        remove( { gid } ) {
            const member = gid.match( '#' );
            if ( member ) {
                dispatch.lists.cdcRemoveItem( { gid } );
            } else {
                dispatch.lists.cdcRemove( { gid } );
            }
        },
        setCurrent( { gid } ) {
            dispatch.lists.setCurrentId( { gid } );
        }
    } )
}

export default lists;